import FeatureFlags from '../models/FeatureFlags';
import useFetchFeatureFlagsQuery from '../queries/useFetchFeatureFlagsQuery';

type FeatureFlagName = keyof Omit<FeatureFlags, 'id'>

const useFeatureFlag = ( flagName: FeatureFlagName ): boolean => {
	const { data: featureFlags } = useFetchFeatureFlagsQuery();
	return featureFlags ? Boolean( featureFlags[ flagName ] ) : false;
};

export default useFeatureFlag;
